import React from "react";
import moment from "moment/min/moment-with-locales";
import { Button } from "primereact/button";
import { SplitButton } from "primereact/splitbutton";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputTextarea } from "primereact/inputtextarea";
import { ProgressSpinner } from "primereact/progressspinner";
import { GaleriaImagens } from "../../screens/Imagens/GaleriaImagens";
import { MedicoService } from "../../service/Medico";

import downloadDicomZip from "../../images/Icons/Icone-DicomZip.svg";
import icoCompartilharBranco from "../../images/Icons/icone-compartilhar-branco.svg";
import icoDowndloadBranco from "../../images/Icons/icone-download-image-branco.svg";
import icoPdfBranco from "../../images/Icons/icone-pdf-branco.svg";
import icoImpressoraBranco from "../../images/Icons/icone-impressora-branco.svg";
import icoBaixarZip from "../../images/Icons/Icone-baixar-zip.svg";

import "./StudyContentModal.css";

const StudyContentModal = ({ parent, pedido, mode }) => {
    const pedidoModal = pedido || parent.state.pedidoModalOpcoes;
    const modalOpcaoSelecionada = parent.state.modalOpcaoSelecionada;

    const prioridadeSelectItems = [
        { label: "Sem prioridade", value: 0 },
        { label: "Baixa", value: 1 },
        { label: "Média", value: 2 },
        { label: "Alta", value: 3 }
    ];

    const renderAcoesDaModal = (pedidoAtual) => {
        if (!pedidoAtual) return null;

        const auth = JSON.parse(sessionStorage.getItem("auth") || "{}");
        const isAcessoCompartilhado = !!auth.TokenPortal;

        const { isMedico, isExecutante } = parent.state;
        const isPerfilMedico = isMedico || isExecutante;

        const acaoVisualizadorAtiva = isPerfilMedico
            ? parent.state.acaoBaixarImagens_visualizador_Medico
            : parent.state.acaoBaixarImagens_visualizador_Paciente;

        const acaoDicomZipAtiva = isPerfilMedico
            ? parent.state.acaoBaixarImagens_dicomZip_Medico
            : parent.state.acaoBaixarImagens_dicomZip_Paciente;

        const totalAcoesAtivas = [acaoVisualizadorAtiva, acaoDicomZipAtiva].filter(Boolean).length;

        return (
            <>
                <div
                    className="ModalNavegacao-Acoes-Galeria"
                    style={{ display: (modalOpcaoSelecionada === "Galeria" && pedidoAtual.possuiJob == false) ? "block" : "none" }}
                >
                    <h2 className="Titulo-Navegacao-Acoes">Baixe ou compartilhe as imagens</h2>
                    <p className="Texto-Navegacao-Acoes">Faça o download das imagens agora mesmo, em zip, ou com o visualizador.</p>
                    <p className="Texto-Navegacao-Acoes">Compartilhe este estudo com seu médicos.</p>

                    <div className="ModalNavegacao-Acoes-Laudo-buttons">
                        {!isAcessoCompartilhado && (
                            <div>
                                {(isPerfilMedico ? parent.state.botaoCompartilharAtivoMedico : parent.state.botaoCompartilharAtivoPaciente) && (
                                    <Button
                                        className={`Button-modal-actions ${parent.state.modalOpcaoSelecionada === "Compartilhar" ? "buttom-modal-selected" : ""}`}
                                        label={
                                            <span className="label-button-content">
                                                <span className="icon-navegacao" style={{ backgroundImage: `url(${icoCompartilharBranco})` }} />
                                                {parent.state.labelBotaoCompartilhar || "Compartilhar"}
                                            </span>
                                        }
                                        onClick={() => parent.setState({ modalOpcaoSelecionada: "Compartilhar", mostrarModalAcoesMobile: false })}
                                    />
                                )}
                            </div>
                        )}

                        <div>
                            {totalAcoesAtivas === 2 && (
                                <SplitButton
                                    className="Button-modal-actions--downlod-images"
                                    label={
                                        <span className="label-button-content">
                                            <span className="icon-navegacao" style={{ backgroundImage: `url(${icoDowndloadBranco})` }} />
                                            {parent.state.lblbtnDownloadVisualizador || "Baixar imagens"}
                                        </span>
                                    }
                                    onClick={() => parent.handleBaixarImagem(pedidoAtual)}
                                    iconpos="right"
                                    appendTo="self"
                                    tooltipOptions={{ position: "bottom" }}
                                    model={[
                                        {
                                            visible: acaoDicomZipAtiva,
                                            label: parent.state.lblbtnDownloadDicomZip || "Baixar DICOM.zip",
                                            icon: <img src={downloadDicomZip} alt="Baixar Imagens" style={{ width: "20px", height: "20px", marginRight: "8px" }} />,
                                            command: () => parent.handleBaixarDicomZip(pedidoAtual)
                                        }
                                    ]}
                                />
                            )}

                            {totalAcoesAtivas === 1 && (
                                <Button
                                    className="Button-modal-actions--downlod-images"
                                    label={
                                        <span className="label-button-content">
                                            <span className="icon-navegacao" style={{ backgroundImage: `url(${icoDowndloadBranco})` }} />
                                            {acaoVisualizadorAtiva
                                                ? parent.state.lblbtnDownloadVisualizador || "Baixar imagens"
                                                : parent.state.lblbtnDownloadDicomZip || "Baixar DICOM.zip"}
                                        </span>
                                    }
                                    onClick={() => acaoVisualizadorAtiva ? parent.handleBaixarImagem(pedidoAtual) : parent.handleBaixarDicomZip(pedidoAtual)}
                                />
                            )}
                        </div>
                    </div>
                </div>

                <div className="ModalNavegacao-Acoes-Galeria-externo" style={{ display: modalOpcaoSelecionada === "Imagens" ? "block" : "none" }}>
                    <h2 className="Titulo-Navegacao-Acoes">Observação</h2>
                    <p className="Texto-Navegacao-Acoes">As imagens apresentadas foram incluídas pelo próprio paciente,</p>
                    <p className="Texto-Navegacao-Acoes">sendo seu conteúdo de inteira responsabilidade do mesmo.</p>
                </div>

                <div
                    className="ModalNavegacao-Acoes-Laudo"
                    style={{ display: (modalOpcaoSelecionada === "Laudo" || modalOpcaoSelecionada === "Compartilhar" || modalOpcaoSelecionada === "Exames externos") ? "block" : "none" }}
                >
                    {parent.mostrarBotaoLaudoNaModal(parent.state.pedidoModalOpcoes) && (
                        <div>
                            <h2 className="Titulo-Navegacao-Acoes">Imprima, baixe ou compartilhe este laudo</h2>
                            <p className="Texto-Navegacao-Acoes">Imprima, compartilhe ou baixe o laudo no formato .pdf</p>

                            <div className="ModalNavegacao-Acoes-Laudo-buttons">
                                <div>
                                    {(isPerfilMedico ? parent.state.botaoImprimirLaudoAtivoMedico : parent.state.botaoImprimirLaudoAtivoPaciente) && (
                                        <Button
                                            className="Button-modal-actions"
                                            label={
                                                <span className="label-button-content">
                                                    <span className="icon-navegacao" style={{ backgroundImage: `url(${icoImpressoraBranco})` }} />
                                                    {parent.state.labelBotaoImprimirLaudo || "Imprimir laudo"}
                                                </span>
                                            }
                                            onClick={() => {
                                                const iframe = document.querySelector(".ModalVisualizador iframe");
                                                if (iframe && iframe.contentWindow) {
                                                    iframe.contentWindow.focus();
                                                    iframe.contentWindow.print();
                                                } else {
                                                    alert("O laudo ainda não foi carregado ou não está disponível para impressão.");
                                                }
                                            }}
                                        />
                                    )}
                                </div>

                                {!isAcessoCompartilhado && (
                                    <div>
                                        {(isPerfilMedico ? parent.state.botaoCompartilharAtivoMedico : parent.state.botaoCompartilharAtivoPaciente) && (
                                            <Button
                                                className={`Button-modal-actions ${parent.state.modalOpcaoSelecionada === "Compartilhar" ? "buttom-modal-selected" : ""}`}
                                                label={
                                                    <span className="label-button-content">
                                                        <span className="icon-navegacao" style={{ backgroundImage: `url(${icoCompartilharBranco})` }} />
                                                        {parent.state.labelBotaoCompartilhar || "Compartilhar"}
                                                    </span>
                                                }
                                                onClick={() => parent.setState({ modalOpcaoSelecionada: "Compartilhar", mostrarModalAcoesMobile: false })}
                                            />
                                        )}
                                    </div>
                                )}

                                <Button
                                    className="Button-modal-actions"
                                    label={
                                        <span className="label-button-content">
                                            <span className="icon-navegacao" style={{ backgroundImage: `url(${icoPdfBranco})` }} />
                                            {parent.state.labelBotaoBaixarLaudoPdf || "Fazer download"}
                                        </span>
                                    }
                                    onClick={() => {
                                        const iframe = document.querySelector(".ModalVisualizador iframe");
                                        if (iframe && iframe.src) {
                                            const link = document.createElement("a");
                                            link.href = iframe.src;
                                            link.download = "Laudo.pdf";
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                        } else {
                                            alert("O laudo ainda não foi carregado ou não está disponível para download.");
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>

                <div className="ModalNavegacao-Acoes-Parecer" style={{ display: (modalOpcaoSelecionada === "Parecer" || modalOpcaoSelecionada === "Anexos") ? "block" : "none" }}>
                    <div style={{ display: "flex" }}>
                        <div>
                            <h2 className="Titulo-Navegacao-Acoes">Baixe as imagens .dicom e o visualizador em pasta .zip</h2>
                            <p className="Texto-Navegacao-Acoes">Para ter acesso às imagens em formato ".dicom" no seu computador, é necessário ter o software instalado</p>
                            <Button
                                className="Button-modal-actions"
                                label={<span className="label-button-content"><span className="icon-navegacao" style={{ backgroundImage: `url(${icoBaixarZip})` }} />Baixar pasta</span>}
                                onClick={() => {
                                    const iframe = document.querySelector(".ModalVisualizador iframe");
                                    if (iframe && iframe.contentWindow) {
                                        iframe.contentWindow.focus();
                                        iframe.contentWindow.print();
                                    } else {
                                        alert("O laudo ainda não foi carregado ou não está disponível para impressão.");
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className="ModalNavegacao-Acoes-Arquivos" style={{ display: modalOpcaoSelecionada === "Arquivos" ? "block" : "none" }}>
                    <div style={{ display: "flex" }}>
                        <div>
                            <h2 className="Titulo-Navegacao-Acoes">Observação</h2>
                            <p className="Texto-Navegacao-Acoes">Este exame foi importado pelo paciente, que assume integralmente a responsabilidade por seu conteúdo.</p>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const renderConteudoModalGenerica = () => {
        const opcao = parent.state.modalOpcaoSelecionada;

        return (
            <>
                <div style={{ width: "100%", height: "100%", position: "relative", display: opcao === "Viewer" ? "block" : "none", overflow: "hidden" }}>
                    {parent.state.viewerSrc ? (
                        <iframe src={parent.state.viewerSrc} title="viewer" width="100%" height="100%" frameBorder="0" allowFullScreen />
                    ) : (
                        <div style={{ display: "grid", placeItems: "center", height: "100%" }}>Carregando viewer...</div>
                    )}
                </div>

                <div style={{ width: "100%", height: "100%", position: "relative", display: opcao === "Galeria" || opcao === "Imagens" ? "block" : "none" }}>
                    <GaleriaImagens
                        selectedPedido={parent.state.pedidoModalOpcoes}
                        servicoImagem={parent.state.pedidoModalOpcoes?.Unidade?.ServicoImagemPortal}
                        panelImageJpegVisible={true}
                        panelImageJpegMaximize={() => parent.panelImageJpegMaximize()}
                        handleFecharImagemJpg={() => parent.setState({ modalOpcoesVisivel: false })}
                        onHideGaleria={() => parent.setState({ modalOpcoesVisivel: false })}
                        mobilecheck={() => parent.mobilecheck()}
                        adicionarHistoricoAcoes={(acao, pedidoId) => parent.AdicionarHistoricoAcoes(acao, pedidoId, parent.state.pedidoModalOpcoes?.Tipo)}
                    />
                </div>

                <div className="modal-Laudo" style={{ display: opcao === "Laudo" ? "block" : "none" }}>
                    <div className="modal-Laudo-estrutura-estrutura">
                        {parent.state.laudoCarregando ? (
                            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#161618", borderRadius: "10px" }}>
                                <ProgressSpinner style={{ width: "100px", height: "100px" }} strokeWidth="4" />
                            </div>
                        ) : (
                            <iframe className="modal-Laudo-estrutura-corpo" src={parent.state.urlLaudoPdf} title="Laudo PDF" style={{ width: "100%", height: "100%", border: "none" }} />
                        )}
                    </div>
                </div>

                {opcao === "Compartilhar" && (
                    <div style={{ width: "100%", height: "100%", position: "relative" }}>
                        <div className="formulario-compartilhar">
                            <div style={{ display: "flex" }}>
                                <div>
                                    <label>Forma de envio</label>
                                    <div className="tabs-envio">
                                        <button className={`tab-envio ${parent.state.formaEnvio === "whatsapp" ? "ativo" : ""}`} onClick={() => parent.setState({ formaEnvio: "whatsapp" })}>WhatsApp</button>
                                        <button className={`tab-envio ${parent.state.formaEnvio === "email" ? "ativo" : ""}`} onClick={() => parent.setState({ formaEnvio: "email" })}>E-mail</button>
                                    </div>
                                </div>

                                <div style={{ display: "flex", width: "100%", color: "black" }}>
                                    <div style={{ marginLeft: "auto" }}>
                                        <div style={{ display: "block" }}>
                                            <div><label>Válido por</label></div>
                                            <div>
                                                <Dropdown
                                                    className="dropdownValidade"
                                                    panelClassName="painel-validade"
                                                    value={parent.state.validadeSelecionada}
                                                    onChange={(e) => parent.setState({ validadeSelecionada: e.value })}
                                                    options={parent.state.validades}
                                                    optionLabel="name"
                                                    placeholder={parent.state.validadeSelecionada}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="campo-envio">
                                {parent.state.formaEnvio === "whatsapp" ? (
                                    <div className="input-com-icone">
                                        <span className="icone-whatsapp" />
                                        <InputMask
                                            className="campo-envio-input"
                                            value={parent.state.celCompartilhar}
                                            onChange={(e) => parent.setState({ celCompartilhar: e.target.value })}
                                            mask="(99) 99999-9999"
                                            placeholder="(99) 99999-9999"
                                        />
                                    </div>
                                ) : (
                                    <div className="input-com-icone">
                                        <span className="icone-email" />
                                        <input
                                            className="campo-envio-input"
                                            type="email"
                                            placeholder="seuemail@exemplo.com"
                                            value={parent.state.emailCompartilhar}
                                            onChange={(e) => parent.setState({ emailCompartilhar: e.target.value })}
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="botoesModalCompartilhar">
                                <Button className="botaoCancelar" label="Cancelar" onClick={() => parent.setState({ modalOpcoesVisivel: false })} />
                                <Button className="botaoCompartilhar" label="Compartilhar" onClick={() => parent.handleCompartilharLinkPortal()} />
                            </div>
                        </div>
                    </div>
                )}

                <div style={{ display: opcao === "Anexos" ? "block" : "none" }}>
                    <div style={{ width: "100%" }} footer={parent.renderFooterAnexo("modalAnexo")} onHide={() => parent.onHide("modalAnexo")}>
                        <div className="card">
                            <DataTable
                                className="tabela-anexos"
                                value={parent.state.isExecutante ? parent.state.listaAnexos : parent.state.listaAnexos?.filter(a => a?.Nome?.toLowerCase().endsWith(".stl"))}
                                tableStyle={{ minWidth: "100%" }}
                            >
                                <Column field="Nome" header="Nome do arquivo" body={parent.nomeArquivoAnexo}></Column>
                                <Column field="Tamanho" header="Tamanho" body={(e) => parent.tamanhoArquivoKB(e)} headerStyle={{ width: "9em" }} ></Column>
                                <Column field="TipoAnexo" header="Formato" body={parent.statusTipoAnexo} headerStyle={{ width: "9em" }} ></Column>
                                <Column field="" header="Ações" headerStyle={{ width: "9em" }} body={(e) => parent.btnAnexoAcoes(parent.state.pedidoModalOpcoes, e)}></Column>
                            </DataTable>
                        </div>
                    </div>
                </div>

                <div style={{ display: opcao === "Arquivos" ? "block" : "none" }}>
                    <div style={{ width: "100%" }}>
                        <div className="card">
                            <DataTable className="tabela-anexos" value={parent.state.pedidoModalOpcoes?.Files || []} tableStyle={{ minWidth: "100%" }}>
                                <Column field="Name" header="Nome do arquivo" />
                                <Column header="Ações" body={parent.renderAcoesArquivoExterno} style={{ width: "10em" }} />
                            </DataTable>
                        </div>
                    </div>
                </div>

                <div style={{ display: opcao === "Parecer" ? "block" : "none" }}>
                    <div className="ParecerMedico">
                        <div className="ParecerMedicoLista">
                            <DataTable value={parent.state.listaParecer} className="p-datatable-gridlines" emptyMessage="Nenhum parecer disponível no momento.">
                                <Column field="DataCadastro" header="Data"></Column>
                                <Column field="Texto" header="Descrição"></Column>
                                <Column header="Prioridade" body={parent.statusPrioridade} />
                            </DataTable>
                        </div>

                        <div className="ParecerMedicoForm">
                            <div className="ParecerMedicoFormInput">
                                <label className="ParecerMedicoInputTextLabel">Parecer Médico:</label>
                                <InputTextarea className="ParecerMedicoInputText" placeholder="Descreva o parecer médico aqui..." value={parent.state.parecerTexto} onChange={(e) => parent.setState({ parecerTexto: e.target.value })} autoResize={true} />
                            </div>

                            <div className="ParecerMedicoFormPrioridade">
                                <div>
                                    <label className="ParecerMedicoPrioridadeLabel">Prioridade: </label>
                                    <Dropdown className="ParecerMedicoPrioridade" value={parent.state.parecerPrioridade} options={prioridadeSelectItems} onChange={(e) => parent.setState({ parecerPrioridade: e.value })} />
                                </div>
                                <div className="ParecerMedicoFormButtons">
                                    <Button label="Cancelar" className="ParecerMedicoFormCancelarButtom" onClick={() => parent.setState({ modalOpcoesVisivel: false })} />
                                    <Button
                                        label="Salvar"
                                        className="ParecerMedicoFormSalvarButtom"
                                        onClick={async () => {
                                            try {
                                                await parent.handleSalvarParecer();
                                                const pedidoRef = parent.state.pedidoModalOpcoes;
                                                if (pedidoRef?.Id) {
                                                    const medicoService = new MedicoService();
                                                    const data = await medicoService.GetParecerMedico(pedidoRef.Id);

                                                    const _listaParecer = data.Comentarios.map((el) => ({
                                                        DataCadastro: moment(el.DataCadastro).format("DD/MM/YYYY"),
                                                        Prioridade: parent.retLegendaPrioridade(el.Prioridade),
                                                        Texto: el.Texto
                                                    }));

                                                    parent.setState({ listaParecer: _listaParecer });
                                                }
                                            } catch (error) {
                                                console.log("Erro ao salvar ou atualizar parecer médico:", error);
                                            }
                                        }}
                                        style={{ marginRight: "10px" }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ display: !opcao ? "block" : "none" }}>
                    <p>Selecione uma opção na lateral.</p>
                </div>
            </>
        );
    };

    return (
        <div className="study-content-modal-root">
            {mode === "actions" ? renderAcoesDaModal(pedidoModal) : renderConteudoModalGenerica()}
        </div>
    );
};

export default StudyContentModal;
